import type { AppRouteModule } from "/@/router/types";

import { LAYOUT } from "/@/router/constant";

const systemRouter: AppRouteModule = {
  path: "/system",
  name: "System",
  component: LAYOUT,
  redirect: "/system/index",
  meta: {
    hideChildrenInMenu: false,
    icon: "ant-design:home-outlined",
    title: "系统管理",
    orderNo: 1,
  },
  children: [
    {
      path: "user",
      name: "SystemUser",
      component: () => import("/@/views/system/user.vue"),
      meta: {
        title: "用户管理",
        hideMenu: false,
      },
    },
  ],
};

export default systemRouter;
